export const ACTIVE_EVENT_IDS_QUERY_PARAM = 'activeEventIds';
export const ACTIVE_EVENT_IDS_2_QUERY_PARAM = 'activeEventIds2';
export const TAB_EVENT_IDS_QUERY_PARAM = 'tabEventIds';
export const TAB_EVENT_IDS_2_QUERY_PARAM = 'tabEventIds2';
export const TAB_EVENT_IDS_SEPARATOR = ',';
export const POS_EVENT_IDS_SEPARATOR = '|';
export const TAB_EVENT_IDS_MAPPING_ID = 'tabEventIdsMappingId';
